import React, { type FC } from 'react'

import { areArrayEquals, type ExcludeValues, isArrayNotEmpty } from '../../../../utils'

import { selectExplorerSubscriptionResponseErrors, type TopicTree } from '../../../../domain'

import { TopicsSubscriptionErrorsPopover } from '../../common'
import { useAppState, useAppUsecase } from '../../State'

export const ErrorInfoPopover: FC<ExcludeValues<Pick<TopicTree, 'fullPath'>, null>> = ({ fullPath }) => {
    const manage = useAppUsecase('explorerTopicManagementUsecase')
    const errors = useAppState((s) => selectExplorerSubscriptionResponseErrors(s, fullPath), areArrayEquals, [fullPath])

    if (!isArrayNotEmpty(errors)) {
        return null
    }

    return (
        <TopicsSubscriptionErrorsPopover
            data-testid={fullPath}
            topics={[fullPath]}
            errors={new Set(errors)}
            onRetry={() => manage.retryTopic(fullPath)}
            onUnsub={() => manage.toggleTopics([fullPath])}
        />
    )
}
